import { render, staticRenderFns } from "./carDetailOwner.vue?vue&type=template&id=1b30c7bc&scoped=true"
import script from "./carDetailOwner.vue?vue&type=script&lang=js"
export * from "./carDetailOwner.vue?vue&type=script&lang=js"
import style0 from "./carDetailOwner.vue?vue&type=style&index=0&id=1b30c7bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b30c7bc",
  null
  
)

export default component.exports